import { createSlice } from "@reduxjs/toolkit";
import { fundRaiserDetailAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const fundRaiserDetailSlice = createSlice({
  name: "fundRaiserDetail",
  initialState: data,
  reducers: {
    fundRaiserDetailSlice(state) {
      state.isLoading = true;
    },
    fundRaiserDetailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    fundRaiserDetailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    fundRaiserDetailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const fundRaiserDetailHandler = (user_id:string,org_id:string) => async (dispatch: any) => {
  try {
    dispatch(fundRaiserDetailAction.fundRaiserDetailSlice());
    const response: any = await fundRaiserDetailAPI(user_id,org_id);
    dispatch(fundRaiserDetailAction.fundRaiserDetailSliceSuccess(response));
  } catch (e: any) {
    dispatch(fundRaiserDetailAction.fundRaiserDetailSliceFailure(e?.response?.data?.message));
    dispatch(fundRaiserDetailAction.fundRaiserDetailSliceReset());
  }
};
export default fundRaiserDetailSlice.reducer;
export const fundRaiserDetailAction = fundRaiserDetailSlice.actions;
